import React, { useLayoutEffect, type ReactNode } from 'react';
import { loadQuery } from 'react-relay';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { JiraLogoPlaceholder } from './JiraLogoPlaceholder.tsx';
import { JiraSpaPageContainer as JiraSpaPageContainerInner } from './JiraSpaPageContainer.tsx';
import QUERY, {
	type JiraSpaPageContainerQuery,
} from './__generated__/JiraSpaPageContainerQuery.graphql';

// This component should very rarely get involved in render, if ever.
// If we're here, it means that a route had no entrypoint definition AND no route-resource definition for the SPA query.
export const JiraSpaFallbackLoader = (props: { children: ReactNode }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const cloudId = useCloudId();
	const queryReference = loadQuery<JiraSpaPageContainerQuery>(
		getRelayEnvironment(),
		QUERY,
		{ cloudId },
		{ fetchPolicy: 'store-or-network' },
	);
	useLayoutEffect(() => {
		const event = createAnalyticsEvent({});
		fireOperationalAnalytics(event, 'jiraSpaPageLayout fallback');
	});
	return (
		<Placeholder name="spa_fallback" fallback={<JiraLogoPlaceholder />}>
			<JiraSpaPageContainerInner queryReference={queryReference}>
				{props.children}
			</JiraSpaPageContainerInner>
		</Placeholder>
	);
};
